(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------
     Header: glass on scroll, mobile menu
     ------------------------------------------------------------------ */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onHeaderScroll = function () {
      var threshold = header.classList.contains('site-header--logo-on-scroll') ? window.innerHeight * 0.45 : 20;
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  $$('[data-nav-toggle]').forEach(function (btn) {
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (header) header.classList.toggle('menu-open', open);
      root.style.overflow = open ? 'hidden' : '';
    };
    btn.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { setOpen(false); btn.focus(); } });
  });

  /* ------------------------------------------------------------------
     Entrance animations (scroll reveal)
     ------------------------------------------------------------------ */
  var countUp = function (el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target) || reduceMotion) return;
    var decimals = (String(target).split('.')[1] || '').length;
    var start = null, dur = 1600;
    var step = function (t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(decimals);
    };
    el.textContent = (0).toFixed(decimals);
    requestAnimationFrame(step);
  };

  var reveal = function (el) {
    el.classList.add('is-revealed');
    $$('[data-count-to]', el).forEach(countUp);
    if (el.hasAttribute('data-count-to')) countUp(el);
  };

  var observer = null;
  var initReveal = function (scope) {
    var items = $$('[data-reveal]:not(.is-revealed)', scope);
    var counters = $$('[data-count-to]', scope);
    if (!root.classList.contains('anim') || designMode || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { reveal(entry.target); observer.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    items.forEach(function (el) { observer.observe(el); });
    counters.forEach(function (el) {
      if (!el.closest('[data-reveal]')) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { countUp(el); io.disconnect(); } }, { threshold: 0.4 });
        io.observe(el);
      }
    });
  };
  initReveal(document);
  /* Safety net: never leave content hidden if something goes wrong. */
  setTimeout(function () {
    $$('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
    });
  }, 2500);

  /* ------------------------------------------------------------------
     Pointer glow on feature tiles
     ------------------------------------------------------------------ */
  document.addEventListener('pointermove', function (e) {
    var tile = e.target.closest && e.target.closest('.feature-tile');
    if (!tile) return;
    var r = tile.getBoundingClientRect();
    tile.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    tile.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* ------------------------------------------------------------------
     Parallax backgrounds
     ------------------------------------------------------------------ */
  var parallaxEls = $$('[data-parallax]');
  var ticking = false;
  var renderParallax = function () {
    ticking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var speed = (parseFloat(el.getAttribute('data-parallax')) || 0) / 100;
      var layer = el.firstElementChild;
      if (!layer) return;
      if (speed === 0 || reduceMotion) { layer.style.transform = ''; layer.style.top = '0'; layer.style.bottom = '0'; return; }
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var overhang = '-' + (speed * 50).toFixed(1) + '%';
      if (layer.style.top !== overhang) { layer.style.top = overhang; layer.style.bottom = overhang; }
      var progress = (vh / 2 - (rect.top + rect.height / 2)) / (vh / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      layer.style.transform = 'translate3d(0,' + (progress * rect.height * speed * 0.5).toFixed(1) + 'px,0)';
    });
  };
  var onParallax = function () { if (!ticking) { ticking = true; requestAnimationFrame(renderParallax); } };
  if (parallaxEls.length) {
    window.addEventListener('scroll', onParallax, { passive: true });
    window.addEventListener('resize', onParallax);
    renderParallax();
  }

  /* ------------------------------------------------------------------
     Hero product carousel
     ------------------------------------------------------------------ */
  function initCarousel(el) {
    if (el.dataset.carouselReady) return;
    el.dataset.carouselReady = '1';
    var slides = $$('[data-slide]', el);
    var dots = $$('[data-carousel-dot]', el);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var delay = (parseInt(el.getAttribute('data-autoplay'), 10) || 0) * 1000;

    var go = function (to) {
      to = (to + slides.length) % slides.length;
      if (to === index) return;
      var prev = slides[index];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      if (prev.tagName === 'A') prev.setAttribute('tabindex', '-1');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 1000);
      var next = slides[to];
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.removeAttribute('tabindex');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === to);
        if (i === to) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      index = to;
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () { stop(); if (delay && !reduceMotion) timer = setInterval(function () { go(index + 1); }, delay); };

    var prevBtn = el.querySelector('[data-carousel-prev]');
    var nextBtn = el.querySelector('[data-carousel-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-carousel-dot'), 10)); start(); }); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(index - 1);
      if (e.key === 'ArrowRight') go(index + 1);
    });
    var startX = null, moved = false;
    el.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
    el.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 40) { moved = true; go(dx < 0 ? index + 1 : index - 1); start(); }
      startX = null;
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    el._goTo = go;
    start();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ------------------------------------------------------------------
     Toast + cart count
     ------------------------------------------------------------------ */
  var toast = document.getElementById('CartToast');
  var toastTimer = null;
  var showToast = function (text) {
    if (!toast) return;
    var t = toast.querySelector('[data-toast-text]');
    if (t && text) t.textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 3800);
  };
  var updateCartCount = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
        });
      }).catch(function () {});
  };

  /* ------------------------------------------------------------------
     Product page
     ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.dataset.productReady) return;
    section.dataset.productReady = '1';

    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    };

    /* Gallery */
    var slides = $$('.pdp__slide[data-media-id]', section);
    var thumbs = $$('[data-thumb]', section);
    var showMedia = function (id) {
      var found = false;
      slides.forEach(function (s) { var on = s.getAttribute('data-media-id') === String(id); s.classList.toggle('is-active', on); if (on) found = true; });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
      return found;
    };
    var activeIndex = function () { for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i; return 0; };
    var step = function (dir) {
      if (!slides.length) return;
      var i = (activeIndex() + dir + slides.length) % slides.length;
      showMedia(slides[i].getAttribute('data-media-id'));
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var stage = section.querySelector('[data-gallery]');
    if (stage) {
      var sx = null;
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 40) step(e.clientX < sx ? 1 : -1); sx = null; });
    }
    var activeSlide = section.querySelector('.pdp__slide.is-active');
    if (activeSlide) showMedia(activeSlide.getAttribute('data-media-id'));

    /* Variants */
    var form = section.querySelector('[data-product-form]');
    var jsonEl = section.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    var idInput = form && form.querySelector('[data-variant-id]');
    var addBtn = form && form.querySelector('[data-add-button]');
    var addText = addBtn && addBtn.querySelector('[data-add-text]');
    var priceEl = section.querySelector('[data-product-price]');
    var stock = section.querySelector('[data-stock]');
    var stockText = section.querySelector('[data-stock-text]');
    var barPrice = section.querySelector('[data-buy-bar-price]');
    var barAdd = section.querySelector('[data-buy-bar-add]');
    var radios = form ? $$('input[type="radio"][data-option-index]', form) : [];

    var selectedOptions = function () {
      var out = [];
      radios.forEach(function (r) { if (r.checked) out[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      return out;
    };
    var markAvailability = function (chosen) {
      radios.forEach(function (r) {
        var idx = parseInt(r.getAttribute('data-option-index'), 10);
        var test = chosen.slice(); test[idx] = r.value;
        var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
        r.closest('.pill').classList.toggle('is-unavailable', !ok);
      });
    };
    var setAvailable = function (available, label) {
      if (addBtn) addBtn.disabled = !available;
      if (addText) addText.textContent = label;
      if (barAdd) barAdd.disabled = !available;
      if (stock) stock.classList.toggle('is-out', !available);
      if (stockText) stockText.textContent = available ? 'In stock' : (label === 'Unavailable' ? 'Unavailable' : 'Sold out');
    };
    var update = function () {
      var chosen = selectedOptions();
      chosen.forEach(function (val, i) { var lbl = section.querySelector('[data-option-value="' + i + '"]'); if (lbl) lbl.textContent = val; });
      markAvailability(chosen);
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!match) { setAvailable(false, 'Unavailable'); return; }
      idInput.value = match.id;
      setAvailable(match.available, match.available ? 'Add to cart' : 'Sold out');
      if (priceEl) {
        var html = '<span class="price">';
        if (match.compare_at_price && match.compare_at_price > match.price) html += '<s class="price__compare">' + money(match.compare_at_price) + '</s>';
        html += '<span class="price__current">' + money(match.price) + '</span></span>';
        priceEl.innerHTML = html;
      }
      if (barPrice) barPrice.textContent = money(match.price);
      if (match.featured_media) showMedia(match.featured_media.id);
      if (!designMode) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    radios.forEach(function (r) { r.addEventListener('change', update); });
    if (radios.length) markAvailability(selectedOptions());

    /* Quantity stepper */
    var qty = section.querySelector('[data-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      qty.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }

    /* AJAX add to cart (falls back to normal submit if fetch fails) */
    var errorEl = form && form.querySelector('[data-form-error]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.hidden = true;
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
            var title = res.data.product_title || 'Item';
            showToast(title + ' added to cart');
            return updateCartCount();
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); });
      });
    }

    /* Mobile sticky buy bar */
    var bar = section.querySelector('[data-buy-bar]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (barAdd) barAdd.tabIndex = visible ? 0 : -1;
      });
      io.observe(addBtn);
      if (barAdd) barAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */
  function initRecs(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.dataset.loaded) return;
    el.dataset.loaded = '1';
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  }
  $$('[data-recommendations]').forEach(initRecs);

  /* ------------------------------------------------------------------
     Lab results search
     ------------------------------------------------------------------ */
  $$('[data-labs-search]').forEach(function (input) {
    var section = input.closest('.labs-section');
    var items = $$('[data-labs-item]', section);
    var empty = section.querySelector('[data-labs-empty]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (li) {
        var match = !q || li.getAttribute('data-labs-item').indexOf(q) > -1;
        li.hidden = !match;
        if (match) { shown++; li.classList.add('is-revealed'); }
      });
      if (empty) empty.hidden = shown > 0;
    });
  });

  /* ------------------------------------------------------------------
     Age gate
     ------------------------------------------------------------------ */
  var gate = document.getElementById('AgeGate');
  if (gate) {
    var KEY = 'script_botanicals_age_verified';
    var verified = false;
    try { verified = window.localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (!verified && !designMode) {
      gate.hidden = false;
      root.classList.add('age-locked');
      var confirmBtn = gate.querySelector('[data-age-confirm]');
      if (confirmBtn) confirmBtn.focus();
    }
    gate.addEventListener('click', function (e) {
      if (!e.target.closest('[data-age-confirm]')) return;
      try { window.localStorage.setItem(KEY, '1'); } catch (err) {}
      gate.hidden = true;
      root.classList.remove('age-locked');
    });
  }

  /* ------------------------------------------------------------------
     Theme editor support
     ------------------------------------------------------------------ */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('[data-carousel]', e.target).forEach(initCarousel);
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('[data-recommendations]', e.target).forEach(initRecs);
    parallaxEls = $$('[data-parallax]');
    onParallax();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    var car = slide && slide.closest('[data-carousel]');
    if (car && car._goTo) car._goTo($$('[data-slide]', car).indexOf(slide));
  });
})();
